import React from 'react';
import { Query } from 'react-apollo';
import { invitationsQuery } from '../../queries/invitations';
import { InvitationsQuery } from '../../queries/__generated__/InvitationsQuery';
import { ScrollView } from '../ui';
import { ErrorScreen, Loading } from '../utils';

const InvitedList = () => (
  <Query<InvitationsQuery> query={invitationsQuery}>
    {({ data, loading, error }) => {
      if (loading) {
        return <Loading />;
      }
      if (error) {
        return <ErrorScreen />;
      }
      const invitations = data!.invitations;

      return (
        <ScrollView className="bg-white b--light-gray">
          <div
            className="dn flex-ns bg-navy white bt bn-ns pt3 pb2 fw5 f6"
            style={{ position: 'sticky', top: 0 }}
          >
            <div className="w-25 ph3 truncate">Name</div>
            <div className="w-25 ph3 truncate">Email</div>
            <div className="w-25 ph3 truncate">Invite Code</div>
            <div className="w-25 ph3 truncate">Accepted</div>
          </div>
          {invitations.map(invite => (
            <div key={invite.id} className="flex-ns bt b--light-gray pv3 pv2-ns f6 lh-copy">
              <div className="w-25-ns ph3 truncate fw5">{invite.name}</div>
              <div className="w-25-ns ph3 truncate">{invite.email}</div>
              <div className="w-25-ns ph3 truncate">{invite.inviteCode}</div>
              <div className="w-25-ns ph3 truncate">{invite.acceptedOn}</div>
            </div>
          ))}
        </ScrollView>
      );
    }}
  </Query>
);

export default InvitedList;
